import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CardTable,
  CardTableRow,
  Chip,
  Grid,
  Typography,
} from '@forgeglobal/design-framework'
import { Criterion } from 'components/segments/Criterion'
import { Routes } from 'util/Routes'
import { SegmentQueryFragment, useAccountTableSchemaQuery } from 'graphql/bindings/AdminBindings'
import { fieldMapFromQuery, parseTotalCondition } from 'util/SegmentUtils'
import React from 'react'
import moment from 'moment'

interface SegmentTableProps {
  segments: SegmentQueryFragment[]
}

const columnDefs = [
  {
    name: 'name',
    label: 'Name',
    minWidth: 150,
    isLabelHidden: false,
  },
  {
    name: 'creator',
    label: 'Creator',
    minWidth: 150,
    isLabelHidden: false,
  },
  {
    name: 'last_modified',
    label: 'Last modified',
    minWidth: 150,
    priority: 2,
    isLabelHidden: false,
  },
  {
    name: 'last_used',
    label: 'Last used',
    minWidth: 150,
    priority: 3,
    isLabelHidden: false,
  },
  {
    name: 'num_accounts_on_last_run',
    label: 'Number of accounts',
    minWidth: 50,
    priority: 4,
    isLabelHidden: false,
  },
]

export const SegmentTable: React.FC<SegmentTableProps> = ({ segments }) => {
  const { data } = useAccountTableSchemaQuery()
  const fieldsMap = fieldMapFromQuery(data)
  return (
    <CardTable colDefs={columnDefs}>
      {segments.map(segment => {
        const {
          id,
          name,
          query,
          created_by: { name: creatorName },
          last_changed_at,
          last_run_at,
          last_run_count,
        } = segment
        const columns = {
          name: <Typography variant="subtitle2">{name}</Typography>,
          creator: (
            <div>
              <Chip color="secondary" label={creatorName} />
            </div>
          ),
          last_modified: <Typography variant="subtitle2">{moment(last_changed_at).format('M/D/YYYY')}</Typography>,
          last_used: <Typography variant="subtitle2">{moment(last_run_at).format('M/D/YYYY')}</Typography>,
          num_accounts_on_last_run: <Typography variant="subtitle2">{last_run_count}</Typography>,
        }

        const criteria = parseTotalCondition(query)

        return (
          <CardTableRow id={id} key={id} columns={columns} link={Routes.segment(id)}>
            <Box width="100%">
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <Card>
                    <CardHeader title="Include" />
                    <CardContent>
                      {criteria.include.map(criterion => (
                        <Criterion key={criterion} criterion={criterion} isPositive fields={fieldsMap} />
                      ))}
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Card>
                    <CardHeader title="Exclude" />
                    <CardContent>
                      {criteria.exclude.map(criterion => (
                        <Criterion key={criterion} criterion={criterion} fields={fieldsMap} />
                      ))}
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          </CardTableRow>
        )
      })}
    </CardTable>
  )
}
